import { MouseEvent } from 'react';

import { InquisitiveActivitiesContentType } from 'global/graphql/scalars.type';
import { ContentCardButtonsWrapper } from 'approot/shared/content-card-buttons/content-card-buttons.style';
import ExpandButton from '../actions/expand-button';
import AssignButton from 'approot/shared/assign/assign-button';
import {
  EVENT_ACTION_OPEN,
  EVENT_CATEGORY_CLASS_TODO,
} from 'approot/shared/data-tracker/data-events.constants';

const ActivityCardActions = ({
  contentType,
  contentId,
  bookmarked,
  canBookmark,
  canLink,
  link,
  linkAriaLabel,
  onLinkClick,
  onAssignSelect,
}: {
  contentType: InquisitiveActivitiesContentType;
  contentId: number;
  isCardButton?: boolean;
  bookmarked?: boolean;
  canBookmark: boolean;
  canLink: boolean;
  link?: string;
  linkAriaLabel?: string;
  onLinkClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  onAssignSelect?: () => void;
}) => {
  return (
    <ContentCardButtonsWrapper>
      {canBookmark && (
        <AssignButton
          assigned={!!bookmarked}
          isSmall
          variant="secondary"
          dataEvent={{
            category: EVENT_CATEGORY_CLASS_TODO,
            action: EVENT_ACTION_OPEN,
            data: {
              target_type: contentType,
              target_identifier: contentId,
              assign_button_location: 'card',
            },
          }}
          onAssignSelect={onAssignSelect}
        />
      )}
      {canLink && link && linkAriaLabel && (
        <ExpandButton
          link={link}
          isSmall
          ariaLabel={linkAriaLabel}
          onLinkClick={onLinkClick}
        />
      )}
    </ContentCardButtonsWrapper>
  );
};

export default ActivityCardActions;
